// https://mui.com/x/react-charts/
// https://mui.com/x/react-charts/pie/
import { PieChart as PieChartMui } from '@mui/x-charts/PieChart';

export default function PieChart({data,width,height}){

	var widthChart = 200;
	if(width){
		widthChart = width;
	}

	var heightChart = 200;
	if(height){
		heightChart = height;
	}

	/*
      data: [
        { id: 0, value: 10, label: 'series A' },
        { id: 1, value: 15, label: 'series B' },
        { id: 2, value: 20, label: 'series C' },
      ]
	*/

	return (
    	<PieChartMui
      		series={[
        		{
          			data: data,
          			//arcLabel: 'value'
        		},
      		]}
      		width={widthChart}
      		height={heightChart}
      		slotProps={{
              	legend: {                
                  	//direction: 'row',
                  	//position: { vertical: 'bottom', horizontal: 'middle' },
                  	//padding: { top: 5 }                  	
              	}
          	}}
    	/>
  );
}